import { EpimsBaseEntityDto } from './epim-base.dto';

import { IsNotEmpty } from 'class-validator';

export class ProgressReportMasterDto extends EpimsBaseEntityDto {

  @IsNotEmpty() ProgressReportDescription: string;
  @IsNotEmpty() DateReported: string;
  @IsNotEmpty() ReportedBy: string;
  @IsNotEmpty() Status: string;
  @IsNotEmpty() ReportTitle: string;
  @IsNotEmpty() ProgressReportTie: string;
                ProjectId: string;

}
